import React from 'react'

import { Box } from '../Box/Box'
import { Text } from '../Text/Text'
import { Inline } from '../Inline/Inline'
import { Icon } from '../Icon/Icon'

export interface InputChipProps {
  children: React.ReactNode
  tone: 'action' | 'positive' | 'negative' | 'caution' | 'light'
  onClear: () => void
}

export const InputChip: React.FC<InputChipProps> = ({ children, tone = 'light', onClear }) => {
  let chipColor
  if (tone === 'light') chipColor = 'var(--colors-background)'
  else chipColor = `var(--colors-${tone}--subtle)`

  return (
    <Box display="flex">
      <Box radius="xxs" background={chipColor} inset="xs">
        <Inline space="xs" alignY="center">
          <Text weight="strong" tone="light">
            {children}
          </Text>
          <Box onClick={onClear} cursor="pointer">
            <Icon name="close" size="xs" tone="light" />
          </Box>
        </Inline>
      </Box>
    </Box>
  )
}
